import { PortfolioService } from '@amzn/awscat-portfolio-assessment-service-client';
import { withAuthContext } from '@amzn/awscat-react-components';
import { useContext, useEffect } from 'react';
import { RouteComponentProps, Switch } from 'react-router-dom';

import AuthenticatedPrivateRoute from './AuthenticatedPrivateRoute';
import { MatchParam } from './common/types';
import PlanningPages from './components/planning/PlanningPages';
import PortfolioMgmtPages from './components/portfolio-mgmt/PortfolioMgmtPages';
import TCOPages from './components/tco/TcoPages';
import { NavigationContext } from './contexts/NavigationContext';
import { PortfolioContext } from './contexts/PortfolioContext';

const portfolioService = new PortfolioService();

function PortfolioSelected(props: RouteComponentProps<MatchParam>) {
    const { params, path } = props.match;
    const { portfolioId } = params;
    const { updatePortfolio } = useContext(PortfolioContext);
    const { setNavigationOpen } = useContext(NavigationContext);

    const loadPortfolioData = async (portfolioId: string) => {
        const portfolio = await portfolioService.get(portfolioId);
        updatePortfolio(portfolio);
    };

    useEffect(() => {
        if (portfolioId) {
            loadPortfolioData(portfolioId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ portfolioId ]);

    useEffect(() => {
        setNavigationOpen();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Switch>
            <AuthenticatedPrivateRoute path={`${path}/management`} component={PortfolioMgmtPages} />
            <AuthenticatedPrivateRoute path={`${path}/tco/:tcoAssessmentId`} component={TCOPages} />
            <AuthenticatedPrivateRoute path={`${path}/planning`} component={PlanningPages} />
        </Switch>
    );
}

export default withAuthContext(PortfolioSelected);
